import React, { createContext, useCallback, useContext } from "react"
import { BaixasStorageKeys, useBaixasStorage } from "../../use-cases/baixas-storage"
import { useGetLoginContato } from "../../../data/api/login-contato/login-contato"
import { usePostCadastrar } from "../../../data/api/cadastrar/cadastrar"
import { CadastrarModel } from "../../../model/api/Cadastrar"
import { useGetLoginRepresentante } from "../../../data/api/login-representante/login-representante"
import { CadastrarContatoModel } from "../../../model/api/Cadastrar/cadastrar-contato-model"
import { usePutContato } from "../../../data/api/atualizar-contato/atualizar-contato"
import { AtualizarContatoModel } from "../../../model/api/Atualizar/cadastrar-contato-model"

export interface SessaoAtualContextValues {
    Login: (email: string, telefone: string) => Promise<void>,
    LoginRepresentante: (senha: string) => Promise<void>,
    Logout: (rota: number) => void,
    Cadastrar: (model: CadastrarModel) => void,
    CadastrarContato: (model: CadastrarContatoModel) => void,
    AtualizarContato: (model: AtualizarContatoModel) => void,
    IrParaRota: () => string,
    DefinirRota: (rota: string) => void,
    FirstAccess: () => number,
    IsValidSession: () => number,
    carregando: boolean
}
const SessaoAtualContext = createContext<SessaoAtualContextValues>({
    Login: (email: string, telefone: string) => { return new Promise<void>(() => true) },
    LoginRepresentante: (senha: string) => { return new Promise<void>(() => true) },
    Cadastrar: (model: CadastrarModel) => { },
    CadastrarContato: (model: CadastrarContatoModel) => { },
    AtualizarContato: (model: AtualizarContatoModel) => { },
    DefinirRota: (rota: string) => { },
    IrParaRota: () => '',
    IsValidSession: () => { return 0 },
    FirstAccess: () => { return 0 },
    Logout: (rota: number) => { },
    carregando: false
})
interface Props {
    children: React.ReactNode;
}
export const SessaoAtualProvider = ({ children }: Props) => {
    const { getRegister, delRegister, exists, setRegister } = useBaixasStorage();
    const { postCadastrar, carregando: postCadastrarCarregando } = usePostCadastrar()
    const { getLoginContato, carregando: getLoginContatoCarregando } = useGetLoginContato()
    const { getLoginRepresentante, carregando: getLoginRepresentanteCarregando } = useGetLoginRepresentante()
    const { putContato, carregando: putContatoCarregando } = usePutContato()

    const carregando =
        putContatoCarregando ||
        getLoginContatoCarregando ||
        getLoginRepresentanteCarregando ||
        postCadastrarCarregando

    const Logout = (rota: number) => {
        if (rota === 1) {
            delRegister(BaixasStorageKeys.dataRepresentante, false)
            window.location.href = '/representante'
        } else {
            delRegister(BaixasStorageKeys.data, false)
            window.location.href = '/login'
        }
    }

    const DefinirRota = useCallback((rota: string) => {
        setRegister(BaixasStorageKeys.ultimaRota, rota, false)
    }, [setRegister])

    const IrParaRota = useCallback(() => {
        const rota = getRegister(BaixasStorageKeys.ultimaRota)
        if (rota.length !== undefined) {
            return rota
        } else {
            return '/saurus-pdv'
        }
    }, [getRegister])

    const LoginRepresentante = useCallback(async (senha: string) => {
        const res = await getLoginRepresentante(senha)
        if (res.erro) {
            throw res.erro
        }
        setRegister(BaixasStorageKeys.dataRepresentante, res.resultado?.data, false);
    }, [getLoginRepresentante, setRegister])

    const Login = useCallback(async (email: string, telefone: string) => {
        const res = await getLoginContato(email, telefone)
        if (res.erro) {
            throw res.erro
        }
        setRegister(BaixasStorageKeys.data, res.resultado?.data, false);
    }, [getLoginContato, setRegister])

    const FirstAccess = useCallback(() => {
        if (exists(BaixasStorageKeys.data, false)) {
            return 1
        } else if (exists(BaixasStorageKeys.dataRepresentante, false)) {
            return 2
        }
        return 0
    }, [exists])

    const Cadastrar = useCallback(async (model: CadastrarModel) => {
        const res = await postCadastrar(model)
        if (res.erro) {
            throw res.erro
        }
        setRegister(BaixasStorageKeys.data, res.resultado?.data, false);
    }, [postCadastrar, setRegister])

    const CadastrarContato = async (model: CadastrarContatoModel) => {
        const res = await postCadastrar(model)
        if (res.erro) {
            throw res.erro
        }
    }

    const AtualizarContato = async (model: AtualizarContatoModel) => {
        const res = await putContato(model)
        if (res.erro) {
            throw res.erro
        }
    }

    const IsValidSession = useCallback((): number => {
        if (exists(BaixasStorageKeys.data, false)) {
            return 1
        } else if (exists(BaixasStorageKeys.dataRepresentante, false)) {
            return 2
        } else {
            return 0
        }
    }, [exists])

    return (
        <SessaoAtualContext.Provider value={{
            Login,
            LoginRepresentante,
            Logout,
            Cadastrar,
            CadastrarContato,
            AtualizarContato,
            DefinirRota,
            IrParaRota,
            IsValidSession,
            FirstAccess,
            carregando
        }}>
            {children}
        </SessaoAtualContext.Provider>
    )
}

export const useSessaoAtual = () => {
    return useContext(SessaoAtualContext);
}